var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{attrs:{"id":"findingsToolbar"}}),_c('bootstrap-table',{ref:"table",attrs:{"columns":_vm.columns,"data":_vm.data,"options":_vm.options},on:{"onLoadSuccess":_vm.tableLoaded}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }